module.exports = __webpack_public_path__ + "assets/img/dingdan.0014ed40.png";